import { InjectionToken } from '@angular/core';

export type Environment = {
    apiLogUrl: string;
    apiUrl: string;
    envName: string;
    production: boolean;
    version: string;
    domain: boolean;
};

export const ENVIRONMENT = new InjectionToken<Environment>('Environment Configuration');